import { getSdk, sdkOpts } from "./sdk";
const sdk = getSdk(sdkOpts());
export const getYoutubeVideosById = (query) => sdk.GetYoutubeVideosByID.queryAsPromise(query).then(r => r.data?.sites?.find?.configByLookup?.page?.block?.channel?.youtube || { videos: [] });
//# sourceMappingURL=Youtube.js.map